import React, { useState, useEffect, useMemo, useRef } from "react";
import jwtDecode from "jwt-decode";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  Link,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import GetAppIcon from "@material-ui/icons/GetApp";
import CloseIcon from "@material-ui/icons/Close";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import moment from "moment";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import { fetchSLFromPODashboard } from "../../../containers/actions/common/purchaseOrderAction";
import { downloadCustomUploadedFile } from "../../../containers/actions/common/fileActions";
import { dateFormated } from "../functionalComponents/dataFormatFunctions";
import ViewRmPmLotTable from "../PurchaseOrderDashbaordIndex/POTabs/ViewRmPmLotTable";
import LotAllocationTable from "../PurchaseOrderDashbaordIndex/POTabs/LotAllocationTable";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  },
  headerSection: {
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    backgroundColor: "#ffffff",
    borderBottom: "none",
    boxShadow: "none",
  },
  headerTitle: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#000",
    marginLeft: theme.spacing(2),
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      background: "transparent",
      borderBottom: "2px solid black",
    },
  },
  backIcon: {
    paddingLeft: theme.spacing(1),
    fontSize: "small",
    color: "#000",
    cursor: "pointer",
  },
  backText: {
    cursor: "pointer",
    fontWeight: 500,
    fontSize: "16px",
    color: "#000",
    marginLeft: theme.spacing(0.5),
  },
  title: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#000",
    margin: 0,
  },
  contentSection: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    maxWidth: "1280px",
    margin: "0 auto",
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: "1.5rem",
    textAlign: "left",
    paddingBottom: "0",
    marginTop: theme.spacing(5),
    marginBottom: "0",
    color: "#000",
    lineHeight: "1.2",
  },
  titleBorder: {
    border: "2px solid #707070",
    display: "flex",
    width: "1.6rem",
    backgroundColor: "#707070",
    marginBottom: theme.spacing(3),
    marginTop: "0.2rem",
  },
  tableContainer: {
    marginBottom: theme.spacing(3),
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflowX: "auto",
    overflowY: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  lotAllocationWrapper: {
    marginBottom: theme.spacing(3),
    "& .MuiTableContainer-root": {
      border: "1px solid #ddd",
      borderRadius: "8px",
      overflowX: "auto",
      overflowY: "hidden",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      marginTop: 0,
      marginBottom: 0,
      maxHeight: "none",
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      backgroundColor: "#ffffff !important",
      fontWeight: "700 !important",
      padding: "12px 16px !important",
      border: "none !important",
      borderBottom: "2px solid #ddd !important",
      fontSize: "14px !important",
      color: "#000 !important",
      whiteSpace: "normal !important",
      wordWrap: "break-word !important",
      overflowWrap: "break-word !important",
      letterSpacing: "0.3px !important",
      verticalAlign: "middle !important",
      lineHeight: "1.3 !important",
      minWidth: "auto !important",
    },
    "& .MuiTableBody-root .MuiTableCell-root": {
      padding: "12px 16px !important",
      border: "none !important",
      borderBottom: "1px solid #f0f0f0 !important",
      fontSize: "14px !important",
      color: "#333 !important",
      backgroundColor: "#ffffff !important",
      whiteSpace: "normal !important",
      wordWrap: "break-word !important",
      overflowWrap: "break-word !important",
      verticalAlign: "top !important",
      lineHeight: "1.5 !important",
    },
    "& .MuiTableRow-root": {
      "&:hover": {
        backgroundColor: "#f5f5f5 !important",
      },
      "&:last-child td": {
        borderBottom: "none !important",
      },
    },
    "& .MuiTable-root": {
      minWidth: 960,
      borderCollapse: "collapse",
      width: "100%",
      tableLayout: "auto",
    },
    "& .MuiIconButton-root": {
      display: "none !important",
    },
    "& svg[class*='MuiSvgIcon-root']": {
      "&[data-testid*='Edit']": {
        display: "none !important",
      },
    },
  },
  viewRmPmLotWrapper: {
    marginBottom: theme.spacing(3),
    "& .MuiTableContainer-root": {
      border: "1px solid #ddd",
      borderRadius: "8px",
      overflowX: "auto",
      overflowY: "hidden",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      marginTop: 0,
      marginBottom: 0,
      maxHeight: "none",
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      backgroundColor: "#ffffff !important",
      fontWeight: "700 !important",
      padding: "12px 16px !important",
      border: "none !important",
      borderBottom: "2px solid #ddd !important",
      fontSize: "14px !important",
      color: "#000 !important",
      whiteSpace: "normal !important",
      wordWrap: "break-word !important",
      overflowWrap: "break-word !important",
      letterSpacing: "0.3px !important",
      verticalAlign: "middle !important",
      lineHeight: "1.3 !important",
    },
    "& .MuiTableBody-root .MuiTableCell-root": {
      padding: "12px 16px !important",
      border: "none !important",
      borderBottom: "1px solid #f0f0f0 !important",
      fontSize: "14px !important",
      color: "#333 !important",
      backgroundColor: "#ffffff !important",
      whiteSpace: "normal !important",
      wordWrap: "break-word !important",
      overflowWrap: "break-word !important",
      verticalAlign: "top !important",
      lineHeight: "1.5 !important",
    },
 
    "& .MuiTableBody-root .MuiTableCell-root[scope='row']": {
      verticalAlign: "middle !important",
    },
  
    "& .MuiTableBody-root .MuiTableCell-root[rowspan]": {
      verticalAlign: "middle !important",
    },
    "& .MuiTableRow-root": {
      "&:hover": {
        backgroundColor: "#f5f5f5 !important",
      },
      "&:last-child td": {
        borderBottom: "none !important",
      },
    },
    "& .MuiTable-root": {
      minWidth: 960,
      borderCollapse: "collapse",
      width: "100%",
      tableLayout: "auto",
    },
  
    "& svg[style*='color: yellow'], & svg[style*='color:yellow'], & svg[style*='stroke: black'], & svg[style*='stroke:black']": {
      display: "none !important",
    },
    "& .MuiTableCell-root div[style*='display: flex']": {
      "& svg": {
        display: "none !important",
      },
    },
 
    "& > div > div[style*='#f9f9f9']": {
      display: "none !important",
    },
    "& > div > div[style*='backgroundColor: #f9f9f9']": {
      display: "none !important",
    },
    "& > div > div[style*='backgroundColor:#f9f9f9']": {
      display: "none !important",
    },
    "& > div > div[style*='background-color: #f9f9f9']": {
      display: "none !important",
    },
    "& > div > div[style*='background-color:#f9f9f9']": {
      display: "none !important",
    },
    "& > div[style*='marginTop'] > div:nth-child(2)": {
      display: "none !important",
    },
    "& > div[style*='margin-top'] > div:nth-child(2)": {
      display: "none !important",
    },
    "& > div > div[style*='marginTop']:not(.MuiTableContainer-root)": {
      display: "none !important",
    },
    "& > div > div[style*='margin-top']:not(.MuiTableContainer-root)": {
      display: "none !important",
    },
    "& > div > div:not(.MuiTableContainer-root)[style*='border']": {
      display: "none !important",
    },
  },
  sectionDivider: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(2),
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    tableLayout: "auto",
    minWidth: 960,
  },
  headerCell: {
    backgroundColor: "#ffffff",
    fontWeight: 700,
    padding: "12px 16px",
    border: "none",
    borderBottom: "2px solid #ddd",
    fontSize: "14px",
    color: "#000",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    letterSpacing: "0.3px",
    verticalAlign: "middle",
    lineHeight: "1.3",
    maxHeight: "none",
  },
  coloredHeaderCell: {
    backgroundColor: "#E8F3F8",
    fontWeight: 700,
    padding: "12px 16px",
    border: "none",
    borderBottom: "none",
    fontSize: "14px",
    color: "#000",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    letterSpacing: "0.3px",
    verticalAlign: "middle",
    lineHeight: "1.3",
    maxHeight: "none",
  },
  ribbonTableContainer: {
    marginBottom: theme.spacing(3),
    marginTop: 0,
    border: "1px solid #d0e0ea",
    borderRadius: "8px",
    overflowX: "auto",
    overflowY: "hidden",
    backgroundColor: "#E8F3F8",
    boxShadow: "none",
  },
  ribbonCell: {
    padding: "12px 16px",
    border: "none",
    borderBottom: "none",
    fontSize: "14px",
    color: "#333",
    backgroundColor: "#E8F3F8",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    verticalAlign: "top",
    lineHeight: "1.5",
  },
  headerDivider: {
    borderBottom: "1px solid #ddd",
    marginBottom: theme.spacing(1),
    marginTop: 0,
  },
  cell: {
    padding: "12px 16px",
    border: "none",
    borderBottom: "1px solid #f0f0f0",
    fontSize: "14px",
    color: "#333",
    backgroundColor: "#ffffff",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    verticalAlign: "top",
    lineHeight: "1.5",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    "&:last-child td": {
      borderBottom: "none",
    },
  },
  productCodeCell: {
    "& strong": {
      color: "#000",
      fontWeight: 700,
      fontSize: "14px",
      display: "block",
      marginBottom: "4px",
    },
    "& .description": {
      color: "#666",
      fontSize: "13px",
      display: "block",
      lineHeight: "1.4",
    },
  },
  productCodeDesc: {
    lineHeight: 1.5,
    display: "flex",
    flexDirection: "column",
    fontSize: "inherit",
    "& .code": {
      display: "block",
      marginBottom: "4px",
      fontWeight: 400,
      color: "#333",
      fontSize: "inherit",
    },
    "& .description": {
      display: "block",
      paddingLeft: "0px",
      fontWeight: 400,
      color: "#333",
      fontSize: "inherit",
      lineHeight: "1.4",
    },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(8),
    minHeight: "400px",
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: "#666",
    fontSize: "14px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    margin: theme.spacing(2),
  },
  cardContainer: {
    marginBottom: theme.spacing(3),
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    height: "100%",
    border: "1px solid #e0e0e0",
  },
  cardContent: {
    padding: theme.spacing(2.5),
    "&:last-child": {
      paddingBottom: theme.spacing(2.5),
    },
  },
  cardTitle: {
    fontWeight: 500,
    fontSize: "1.5rem",
    textAlign: "left",
    paddingBottom: "0",
    marginBottom: "0",
    color: "#000",
    lineHeight: "1.2",
  },
  cardTitleBorder: {
    border: "2px solid #707070",
    display: "flex",
    width: "1.6rem",
    backgroundColor: "#707070",
    marginBottom: theme.spacing(2),
    marginTop: "0.2rem",
  },
  cardRow: {
    display: "flex",
    marginBottom: theme.spacing(2),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  cardField: {
    flex: 1,
    paddingRight: theme.spacing(2),
    "&:last-child": {
      paddingRight: 0,
    },
  },
  cardLabel: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#000",
    marginBottom: theme.spacing(0.75),
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    lineHeight: "1.4",
  },
  cardValue: {
    fontSize: "14px",
    color: "#000",
    fontWeight: 400,
    wordBreak: "break-word",
    lineHeight: "1.5",
  },
}));

const PODetails = ({ poData, schrockenSLID, onClose }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [poDetails, setPoDetails] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [documentsList, setDocumentsList] = useState([]); 
  const [batchAllocationData, setBatchAllocationData] = useState([]);
  const [batchDetails, setBatchDetails] = useState(null);
  const [batchAllocationLoading, setBatchAllocationLoading] = useState(false);
  const [batchAllocationError, setBatchAllocationError] = useState(false);
  const [schrockenSLIDValue, setSchrockenSLIDValue] = useState(null);
  const [formNumberDialogOpen, setFormNumberDialogOpen] = useState(false);

  // NEW: Comments state (F9)
  const [comments, setComments] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [commentsOpen, setCommentsOpen] = useState(true);
  const commentsContainerRef = useRef(null);

  const hasFetchedRef = useRef(false);
  const previousPoDataRef = useRef(null);
  const apiResponseData = apiData?.data || apiData;
  const scheduleLine = useMemo(() => {
    const data = apiData?.data || apiData;
    return data?.scheduleLineDetails || {};
  }, [apiData]);

  // NEW: Fetch comments when schrockenSLID is set (F9)
  useEffect(() => {
    if (!schrockenSLID) return;
    const tokenData = jwtDecode(localStorage.getItem("authToken"));
    const fetchComments = async () => {
      setCommentsLoading(true);
      try {
        const response = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItemChatData`,
          {
            purchaseOrderNumber: scheduleLine?.scheduleAgreementNumber || poDetails?.poNumber || "",
            schrockenPOLineID: schrockenSLID,
          },
          { headers: { authtoken: localStorage.getItem("authToken") } }
        );
        if (response.data?.status) {
          const raw = response.data.chatData?.poLineItemChatDataResult || [];
          const formatted = raw.map((chat) => ({
            sender: chat.chatSenderName,
            time: moment(chat.chatTimestamp).format("DD-MMM-YYYY HH:mm").toUpperCase(),
            text: chat.chatData,
            type: chat.chatSenderEmail === tokenData.email_address ? "sent" : "received",
            isExcelUpload: chat.excelFileUpload,
            file: chat.chatFileName || null,
            schrockenChatID: chat.schrockenChatID || null,
            chatFileHash: chat.chatFileHash || null,
          }));
          setComments(formatted);
          setTimeout(() => {
            if (commentsContainerRef.current) {
              commentsContainerRef.current.scrollTop = commentsContainerRef.current.scrollHeight;
            }
          }, 100);
        }
      } catch (err) {
        console.error("Error fetching comments:", err);
      } finally {
        setCommentsLoading(false);
      }
    };
    fetchComments();
  }, [schrockenSLID, scheduleLine]);

  // NEW: Download comment file attachment (F9)
  const handleDownloadCommentFile = (schrockenChatID) => {
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadChatFile`,
        { docType: "chat", schrockenChatID },
        { headers: { authtoken: localStorage.getItem("authToken") } }
      )
      .then((res) => {
        if (res.data.status) {
          const byteArray = new Uint8Array(res.data.fileData.data);
          const a = window.document.createElement("a");
          a.href = window.URL.createObjectURL(new Blob([byteArray], { type: "application/octet-stream" }));
          a.download = res.data.fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((err) => console.error("Error downloading comment file:", err));
  };

  useEffect(() => {
    const rowData = poData || location.state?.poData;
    
    // Check if poData has changed - if so, reset fetch ref
    const poDataKey = rowData?.schrockenSLID || rowData?.id || JSON.stringify(rowData);
    if (previousPoDataRef.current !== poDataKey) {
      hasFetchedRef.current = false;
      setLoading(true); 
      previousPoDataRef.current = poDataKey;
    }
    
    if (hasFetchedRef.current) {
      return;
    }
    
    let isMounted = true; 
    
    const fetchDetails = async () => {
      // Mark as fetched
      hasFetchedRef.current = true;
      
      try {
        if (!rowData) {
          console.warn("No PO data found");
          if (isMounted) {
            setLoading(false);
          }
          return;
        }
        
        // Set initial data from props/state
        if (isMounted) {
          setPoDetails(rowData);
          if (rowData.batchAllocationDetails && rowData.batchAllocationDetails.length > 0) {
            setBatchAllocationData(rowData.batchAllocationDetails);
            setBatchAllocationLoading(false); // Data already available, no loading needed
          } else {
            setBatchAllocationLoading(true);
            setBatchAllocationData([]);
          }
        }
        
        const schrockenSLIDValue = schrockenSLID ||  // From props (preferred)
                                    location.state?.schrockenSLID ||  // From navigation state
                                    rowData.schrockenSLID ||
                                    rowData.scheduleLineDetails?.schrockenSLID;
        
       
        
        if (!schrockenSLIDValue) {
          console.warn(" No schrockenSLID found in row data");
          if (isMounted) {
            setLoading(false);
          }
          return;
        }
        
        // Store schrockenSLID for use in dataSource
        if (isMounted) {
          setSchrockenSLIDValue(schrockenSLIDValue);
        }
        
      
        
        // Step 1: First call the SL API to get complete data including batchDetails
        let slApiData = null;
        try {
          const slResult = await dispatch(fetchSLFromPODashboard(schrockenSLIDValue));
          if (slResult && isMounted) {
            slApiData = slResult;
            setApiData(slResult);
           
          } else {
            console.warn("fetchSLFromPODashboard returned no data");
          }
        } catch (error) {
          console.error("Error fetching SL data:", error);
        }
        
        // Only update state if component is still mounted
        if (!isMounted) return;
        
        const apiResponseData = slApiData?.data || slApiData;
        
       
        
        if (!apiResponseData || apiResponseData?.status === false || !apiResponseData.scheduleLineDetails) {
          if (isMounted) {
            setLoading(false);
            setBatchAllocationLoading(false);
          }
          return;
        }
        
        let batchDetailsForTable = null;
        if (apiResponseData?.batchDetails) {
          batchDetailsForTable = Array.isArray(apiResponseData.batchDetails) 
            ? apiResponseData.batchDetails[0] 
            : apiResponseData.batchDetails;
        } else {
          let batchDetails = rowData.batchDetails;
          if (Array.isArray(batchDetails) && batchDetails.length > 0) {
            batchDetailsForTable = batchDetails[0];
          } else if (batchDetails) {
            batchDetailsForTable = batchDetails;
          }
        }
        
        if (isMounted) {
          setBatchDetails(batchDetailsForTable || {});
        }
        
        if (isMounted) {
          setBatchAllocationLoading(true);
        }
        
        if (batchDetailsForTable) {
          try {
            let batchData = [];
            
            if (batchDetailsForTable.bomConsumptionAddedIndicator) {
              const batchID = batchDetailsForTable.schrockenDeliveryScheduleBatchID;
              const batchSize = batchDetailsForTable.batchSize;
              
              if (batchID && batchSize) {
                const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActualNew/${batchID}/${batchSize}`;
                const res = await axios.get(url);
               
                if (res.data?.status && res.data.data && res.data.data.length > 0) {
                  batchData = res.data.data;
                 
                } else {
                  console.warn("No batch allocation data (planned and actual)");
                }
              }
            } else {
              const slID = schrockenSLID || apiResponseData?.scheduleLineDetails?.schrockenSLID;
              
             
              if (slID && slID !== undefined) {
                const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNew/${slID}`;
               
                const res = await axios.get(url);
               
                
                if (res.data?.status && res.data.data?.componentAllocationDataList && res.data.data.componentAllocationDataList.length > 0) {
                  batchData = res.data.data.componentAllocationDataList;
                  
                } else {
                  console.warn(" No batch allocation data (POLine)");
                }
              } else {
                console.error(" No schrockenSLID found in API response! Cannot call fetchComponentAllocationForPOLineNew");
                console.error("API Response Data:", apiResponseData);
              }
            }
            
            if (isMounted) {
              setBatchAllocationData(batchData);
              setBatchAllocationError(false);
              setBatchAllocationLoading(false);
            }
          } catch (error) {
            console.error("Error fetching batch allocation:", error);
            if (isMounted) {
              setBatchAllocationData([]);
              setBatchAllocationError(true);
              setBatchAllocationLoading(false);
            }
          }
        } else {
          // No batchDetails available, set empty data
          if (isMounted) {
            setBatchAllocationData([]);
            setBatchAllocationError(false);
            setBatchAllocationLoading(false);
          }
        }
        
        // Set loading to false after all data is loaded
        if (isMounted) {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching PO details:", error);
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    
    fetchDetails();
    
    // Cleanup function to prevent state updates after unmount
    return () => {
      isMounted = false;
    };
  }, [poData, schrockenSLID]); 

  // Fetch documents for Attached Documents and Artwork Document columns
  useEffect(() => {
    const fetchDocuments = async () => {
      // Handle nested API response structure
      const apiResponseData = apiData?.data || apiData;
      const schrockenSLID = apiResponseData?.scheduleLineDetails?.schrockenSLID || poDetails?.scheduleLineDetails?.schrockenSLID;
      
      if (schrockenSLID) {
        try {
          const res = await axios.get(
            `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllFilesForSL/${schrockenSLID}`
          );
          if (res.data?.status && res.data?.data) {
            setDocumentsList(res.data.data.customFiles || []);
          }
        } catch (err) {
          
        }
      }
    };
    
    if (apiData || poDetails) {
      fetchDocuments();
    }
  }, [apiData, poDetails]);

  const handleBack = () => {
    if (onClose) {
      onClose();
    } else {
      history.push(
        `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/inactivePOs`
      );
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    try {
      return moment(dateString).format("DD-MMM-YYYY").toUpperCase();
    } catch (e) {
      return "NA";
    }
  };

  const formatBatchNumbers = (row) => {
    if (row.batchDetails && Array.isArray(row.batchDetails) && row.batchDetails.length > 0) {
      return row.batchDetails.map(batch => batch.vendorBatchNumber || batch.batchNumber).filter(Boolean).join(", ");
    }
    const scheduleLine = row.scheduleLineDetails || row;
    if (scheduleLine.vendorBatchNumber) {
      return scheduleLine.vendorBatchNumber;
    }
    return "NA";
  };

  // Prepare dataSource for LotAllocationTable (uses same structure as PO Dashboard)
  const dataSource = useMemo(() => {
    if (apiData) {
      const apiResponseData = apiData?.data || apiData;
      
     
      let finalBatchDetails = apiResponseData?.batchDetails || {};
      if (Array.isArray(finalBatchDetails) && finalBatchDetails.length > 0) {
        finalBatchDetails = finalBatchDetails[0];
      }
      
      return {
        scheduleLineDetails: apiResponseData?.scheduleLineDetails || {},
        batchDetails: finalBatchDetails,
        batchAllocationDetails: apiResponseData?.batchAllocationDetails || [],
      };
    }
    
    // Fallback to location state if API hasn't loaded
    let finalBatchDetails = poDetails?.batchDetails || batchDetails || {};
    if (Array.isArray(finalBatchDetails) && finalBatchDetails.length > 0) {
      finalBatchDetails = finalBatchDetails[0];
    }
    
    return {
      scheduleLineDetails: poDetails?.scheduleLineDetails || {},
      batchDetails: finalBatchDetails,
      batchAllocationDetails: poDetails?.batchAllocationDetails || [],
    };
  }, [apiData, poDetails, batchDetails]);
  
 
  
  
  const batchDetailsData = apiResponseData?.batchDetails || {};
  
  const rowData = poData || location.state?.poData;
  
  const getBatchNumbersFromProps = () => {
    if (rowData?.batchDetails) {
      if (Array.isArray(rowData.batchDetails) && rowData.batchDetails.length > 0) {
        return rowData.batchDetails.map(batch => batch.vendorBatchNumber || batch.batchNumber).filter(Boolean).join(", ");
      } else if (rowData.batchDetails.vendorBatchNumber) {
        return rowData.batchDetails.vendorBatchNumber;
      } else if (rowData.batchDetails.batchNumber) {
        return rowData.batchDetails.batchNumber;
      }
    }
    if (rowData?.batchNumber) {
      return rowData.batchNumber;
    }
    return null;
  };
  
  const poNumber = scheduleLine.scheduleAgreementNumber || "NA";
  const productCode = scheduleLine.fgMaterialCode || "NA";
  const productDescription = scheduleLine.fgMaterialName || "NA";
  const batchNumbers = getBatchNumbersFromProps() || batchDetailsData?.vendorBatchNumber || "NA";
  const poQty = scheduleLine.committedQuantity || batchDetailsData?.batchSize  || "NA";
  const uom = scheduleLine.uom || "NA";
  const cmo = scheduleLine.vendorName || "NA";
  const cmoId = scheduleLine.vendorNumber || "NA";
  const plantId = scheduleLine.vendorPlant || "NA";
  const storageLocationId = scheduleLine.storageLocation || "NA";
  const cmoSalesOrderNumber = scheduleLine.cmoSalesOrderNumber || "NA";
  const mfgPlantShortName = scheduleLine.mfgPlantShortName || "NA";
  const mfgPlantId = scheduleLine.mfgPlantId || "NA";
  const cmoHasMultipleSites = scheduleLine.cmoHasMultipleSites || false;
  // Product Details Section - Direct mapping from API response
  const productType = scheduleLine.productTypeName || "NA";
  const brand = scheduleLine.brand || "NA";
  const market = scheduleLine.marketOrder || "NA";
  const euImportationSampling = scheduleLine.EUImportationSamplingReqd; 
  const euImportationSamplingQty = scheduleLine.EUImportationSamplingQty || "NA";
  const stabilityReqSampling = scheduleLine.stabilityReqmtSampling;
  const stabilityRegSamplingQty = scheduleLine.stabilityReqmtSamplingQty || "NA";
  const artworkRequired = scheduleLine.artworkRequired; 
  const artworkRefNumber = scheduleLine.artworkReferenceNumber || "NA";

  // Other PO Details Section - Direct mapping from API response
  const addresseeOrg = scheduleLine.deliveryAddresseeOrgName || "NA";
  const city = scheduleLine.deliveryAddresseeCity || "NA";
  const country = scheduleLine.deliveryAddresseeCountry || "NA";
  const actualCMODispatchDate = batchDetailsData?.dispatchDate || "NA";
  const receiptCollectionDate = batchDetailsData?.actualDeliveryDate || "NA";
  const dateOfCreation = scheduleLine.creationDate || "NA";
  const originalQty = scheduleLine.requestedQuantity || "NA";

  
  const deliveryTo = scheduleLine.deliveryAddresseeOrgName || "NA";
  const deliveryPlantId = scheduleLine.vendorPlant || "NA";
  const deliveryStorageLocationId = scheduleLine.storageLocation || "NA";

  // Batch Allocation Data - Use fetched batchAllocationData state (from API call based on bomConsumptionAddedIndicator)

  const formatValue = (value) => {
    if (value === "NA" || value === null || value === undefined || value === "") {
      return "NA";
    }
    return value;
  };

  const formatBooleanValue = (value) => {
    if (value === true) {
      return "Yes";
    } else if (value === false) {
      return "No";
    } else {
      return "NA";
    }
  };

  const formatArtworkRequired = (value) => {
    if (value === true) {
      return "Yes (New)";
    } else if (value === false) {
      return "No (Current)";
    } else {
      return "NA";
    }
  };

  // Show loading state while API is loading
  if (loading) {
    return (
      <Box className={classes.root}>
        <Box className={classes.headerSection}>
          <div className={classes.backButton} onClick={handleBack}>
            <ArrowBackIosIcon className={classes.backIcon} onClick={handleBack} />
            <Typography className={classes.backText} onClick={handleBack}>
              Back
            </Typography>
          </div>
          <Typography className={classes.headerTitle}>{localStorage.getItem("collabType") === "CMO" ? "SO Details" : "PO Details"}</Typography>
        </Box>
        <Box className={classes.headerDivider}></Box>
        <Box className={classes.loadingContainer}>
          <CircularProgress size={50} />
        </Box>
      </Box>
    );
  }

  return (
    <React.Fragment>
    <Box className={classes.root}>
      {/* Header Section */}
      <Box className={classes.headerSection}>
        <div className={classes.backButton} onClick={handleBack}>
          <ArrowBackIosIcon className={classes.backIcon} onClick={handleBack} />
          <Typography className={classes.backText} onClick={handleBack}>
            Back
          </Typography>
        </div>
        <Typography className={classes.headerTitle}>{localStorage.getItem("collabType") === "CMO" ? "SO Details" : "PO Details"}</Typography>
      </Box>

      <Box className={classes.headerDivider}></Box>

      <Box className={classes.contentSection}>

      <Box>
        <TableContainer className={classes.ribbonTableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.coloredHeaderCell}>{localStorage.getItem("collabType") === "CMO" ? "SO Number" : "PO Number"}</TableCell>
                <TableCell className={classes.coloredHeaderCell}>
                  Sponsor Product Code /<br />Description
                </TableCell>
                <TableCell className={classes.coloredHeaderCell}>Batch Number</TableCell>
                <TableCell className={classes.coloredHeaderCell} align="right">{localStorage.getItem("collabType") === "CMO" ? "SO Qty." : "PO Qty."}</TableCell>
                <TableCell className={classes.coloredHeaderCell}>UoM</TableCell>
                <TableCell className={classes.coloredHeaderCell}>CMO</TableCell>
                <TableCell className={classes.coloredHeaderCell}>CMO ID</TableCell>
                {cmoHasMultipleSites ? <TableCell className={classes.coloredHeaderCell}>MFG Plant</TableCell> : null}
                <TableCell className={classes.coloredHeaderCell}>Plant ID</TableCell>
                <TableCell className={classes.coloredHeaderCell}>Storage Location ID</TableCell>
                <TableCell className={classes.coloredHeaderCell}>
                  CMO Sales Order<br />Document
                </TableCell>
                <TableCell className={classes.coloredHeaderCell}>
                  CMO Sales Order<br />Number
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className={classes.ribbonCell}>{formatValue(poNumber)}</TableCell>
                <TableCell className={classes.ribbonCell}>
                  <div className={classes.productCodeDesc}>
                    <span className="code">{formatValue(productCode)} /</span>
                    <span className="description">{formatValue(productDescription)}</span>
                  </div>
                </TableCell>
                <TableCell className={classes.ribbonCell}>{formatValue(batchNumbers)}</TableCell>
                <TableCell className={classes.ribbonCell} align="right">{formatValue(poQty)}</TableCell>
                <TableCell className={classes.ribbonCell}>{formatValue(uom)}</TableCell>
                <TableCell className={classes.ribbonCell}>{formatValue(cmo)}</TableCell>
                <TableCell className={classes.ribbonCell}>{formatValue(cmoId)}</TableCell>
                {cmoHasMultipleSites ? <TableCell className={classes.ribbonCell}>{formatValue(mfgPlantShortName)}</TableCell> : null}
                <TableCell className={classes.ribbonCell}>{formatValue(plantId)}</TableCell>
                <TableCell className={classes.ribbonCell}>{formatValue(storageLocationId)}</TableCell>
                <TableCell className={classes.ribbonCell} style={{ wordBreak: "break-word" }}>
                  {(() => {
                    const file = documentsList.find(
                      (file) => file.customFileType === "salesOrder"
                    );
                    if (file) {
                      return (
                        <Link
                          style={{
                            color: "#1a0dab",
                            textDecoration: "none",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                          onClick={() => {
                            const fileData = {
                              schrockenCustomFileID: file.schrockenCustomFileID,
                            };
                            dispatch(downloadCustomUploadedFile(fileData));
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.textDecoration = "underline";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.textDecoration = "none";
                          }}
                        >
                          {file.customFileName}
                        </Link>
                      );
                    } else {
                      return "NA";
                    }
                  })()}
                </TableCell>
                <TableCell className={classes.ribbonCell}>{formatValue(cmoSalesOrderNumber)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box style={{ marginTop: "40px", marginBottom: "30px" }}>
          <Divider />
        </Box>
      </Box>

      {/* Product Details Table */}
      <Box>
        <Typography className={classes.sectionTitle}>Product Details</Typography>
        <span className={classes.titleBorder}></span>
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>Product Type</TableCell>
                <TableCell className={classes.headerCell}>Brand</TableCell>
                <TableCell className={classes.headerCell}>Market</TableCell>
                <TableCell className={classes.headerCell}>
                  EU Importation<br />Sampling
                </TableCell>
                <TableCell className={classes.headerCell}>
                  EU Importation<br />Sampling Qty.
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Stability Req<br />Sampling
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Stability Req. Sampling<br />Qty./Form Number
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Form Number<br />Document
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Artwork<br />Required
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Artwork Ref.<br />Number
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Artwork<br />Document
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.cell}>{formatValue(productType)}</TableCell>
                <TableCell className={classes.cell}>{formatValue(brand)}</TableCell>
                <TableCell className={classes.cell}>{formatValue(market)}</TableCell>
                <TableCell className={classes.cell}>{formatBooleanValue(euImportationSampling)}</TableCell>
                <TableCell className={classes.cell}>{formatValue(euImportationSamplingQty)}</TableCell>
                <TableCell className={classes.cell}>{formatBooleanValue(stabilityReqSampling)}</TableCell>
                <TableCell className={classes.cell}>{formatValue(stabilityRegSamplingQty)}</TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {(() => {
                    const formNumberFiles = documentsList.filter(
                      (file) => file.customFileType === "formNumberDoc"
                    );
                    if (formNumberFiles.length > 0) {
                      return (
                        <Link
                          style={{
                            color: "#1a0dab",
                            textDecoration: "underline",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                          onClick={() => setFormNumberDialogOpen(true)}
                        >
                          View Documents ({formNumberFiles.length})
                        </Link>
                      );
                    } else {
                      return "NA";
                    }
                  })()}
                </TableCell>
                <TableCell className={classes.cell}>{formatArtworkRequired(artworkRequired)}</TableCell>
                <TableCell className={classes.cell}>{formatValue(artworkRefNumber)}</TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {documentsList.filter((file) => file.customFileType === "artwork").length > 0 ? (
                    <Box style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      {documentsList
                        .filter((file) => file.customFileType === "artwork")
                        .map((doc, docIndex) => (
                          <Link
                            key={docIndex}
                            style={{
                              color: "#1a0dab",
                              textDecoration: "none",
                              cursor: "pointer",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              const fileData = {
                                schrockenCustomFileID: doc.schrockenCustomFileID,
                              };
                              dispatch(downloadCustomUploadedFile(fileData));
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.textDecoration = "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.textDecoration = "none";
                            }}
                          >
                            {doc.customFileName}
                          </Link>
                        ))}
                    </Box>
                  ) : (
                    "NA"
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box style={{ marginTop: "40px", marginBottom: "30px" }}>
          <Divider />
        </Box>
      </Box>

      <Box>
        <Typography className={classes.sectionTitle}>Batch Allocation</Typography>
        <span className={classes.titleBorder}></span>
        {/* Use ViewRmPmLotTable when bomConsumptionAddedIndicator is true (same as main PO dashboard) */}
        {batchDetails && batchDetails.bomConsumptionAddedIndicator ? (
          <Box className={classes.viewRmPmLotWrapper}>
            <ViewRmPmLotTable
              apiData={batchAllocationData}
              loading={batchAllocationLoading}
              error={batchAllocationError}
              batchDetails={batchDetails}
            />
          </Box>
        ) : (
        
          <Box className={classes.lotAllocationWrapper}>
            <LotAllocationTable
              data={dataSource}
              featuresAccess={{}}
              showPencilIcon={false}
              preFetchedData={batchAllocationData}
            />
          </Box>
          /* Old custom table code kept as fallback (commented out)
          <TableContainer className={classes.tableContainer}>
            <Table className={classes.table} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerCell}>
                    Material Code /<br />Description
                  </TableCell>
                  <TableCell className={classes.headerCell} align="right">
                    Material BoM<br />Qty.
                  </TableCell>
                  <TableCell className={classes.headerCell}>UoM</TableCell>
                  <TableCell className={classes.headerCell}>
                    Material Batch<br />Numbers
                  </TableCell>
                  <TableCell className={classes.headerCell} align="right">
                    Net Available<br />Qty.
                  </TableCell>
                  <TableCell className={classes.headerCell}>Expiry Date</TableCell>
                  <TableCell className={classes.headerCell} align="right">
                    Planned Allocated<br />Qty.
                  </TableCell>
                  <TableCell className={classes.headerCell} align="right">
                    Actual Allocated<br />Qty.
                  </TableCell>
                  <TableCell className={classes.headerCell} align="right">
                    Quantity Variance<br />(%)
                  </TableCell>
                  <TableCell className={classes.headerCell} align="center">Batch Mismatch</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {batchAllocationData.length > 0 ? (
                  batchAllocationData.map((component, index) => (
                    <React.Fragment key={index}>
                      {component?.lotNumberAllocationDetails && Array.isArray(component.lotNumberAllocationDetails) && component.lotNumberAllocationDetails.length > 0 ? (
                        component.lotNumberAllocationDetails.map((lot, lotIndex) => (
                          <TableRow key={lotIndex} className={classes.tableRow}>
                            {lotIndex === 0 && (
                              <TableCell 
                                className={`${classes.cell} ${classes.productCodeCell}`} 
                                style={{ wordBreak: "break-word" }}
                                rowSpan={component.lotNumberAllocationDetails.length}
                                align="left"
                              >
                                <strong>{formatValue(component?.componentAllocationDetails?.componentCode)}</strong>
                                <span className="description">{formatValue(component?.componentAllocationDetails?.componentName || component?.componentAllocationDetails?.componentDescription)}</span>
                              </TableCell>
                            )}
                            {lotIndex === 0 && (
                              <TableCell 
                                className={classes.cell} 
                                align="right" 
                                style={{ wordBreak: "break-word" }}
                                rowSpan={component.lotNumberAllocationDetails.length}
                              >
                                {component?.componentAllocationDetails?.componentQuantity !== undefined && 
                                 component?.componentAllocationDetails?.componentQuantity !== null
                                  ? Number(component.componentAllocationDetails.componentQuantity).toFixed(3)
                                  : "NA"}
                              </TableCell>
                            )}
                            {lotIndex === 0 && (
                              <TableCell 
                                className={classes.cell} 
                                style={{ wordBreak: "break-word" }}
                                rowSpan={component.lotNumberAllocationDetails.length}
                                align="left"
                              >
                                {formatValue(component?.componentAllocationDetails?.componentUOM)}
                              </TableCell>
                            )}
                            <TableCell className={classes.cell} style={{ wordBreak: "break-word" }} align="left">
                              {formatValue(lot?.lotNumber)}
                            </TableCell>
                            <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>
                              {lot?.netAvailableQuantity !== undefined && lot?.netAvailableQuantity !== null
                                ? lot.netAvailableQuantity === 0
                                  ? 0
                                  : Number(lot.netAvailableQuantity).toFixed(3)
                                : "NA"}
                            </TableCell>
                            <TableCell className={classes.cell} style={{ wordBreak: "break-word" }} align="right">
                              {formatValue(formatDate(lot?.expiryDate))}
                            </TableCell>
                            <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>
                              {lot?.plannedAllocatedQuantity !== undefined && lot?.plannedAllocatedQuantity !== null
                                ? lot.plannedAllocatedQuantity === 0
                                  ? 0
                                  : Number(lot.plannedAllocatedQuantity).toFixed(3)
                                : "NA"}
                            </TableCell>
                            <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>
                              {lot?.actualAllocatedQuantity !== undefined && lot?.actualAllocatedQuantity !== null
                                ? lot.actualAllocatedQuantity === 0
                                  ? 0
                                  : Number(lot.actualAllocatedQuantity).toFixed(3)
                                : "NA"}
                            </TableCell>
                            {lotIndex === 0 && (
                              <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }} rowSpan={component.lotNumberAllocationDetails.length}>
                                {component?.quantityVariance !== undefined && component?.quantityVariance !== null && component?.quantityVariance !== "NA" ? (
                                  <span style={{ color: component?.quantityVariancePresent ? "red" : "black" }}>
                                    {Number(component.quantityVariance).toFixed(2)}
                                  </span>
                                ) : "NA"}
                              </TableCell>
                            )}
                            {lotIndex === 0 && (
                              <TableCell className={classes.cell} style={{ wordBreak: "break-word" }} align="center" rowSpan={component.lotNumberAllocationDetails.length}>
                                {component?.batchMismatch === "YES" || component?.lotMismatch || component?.lotsMismatch ? (
                                  <span style={{ color: "red" }}>Yes</span>
                                ) : "No"}
                              </TableCell>
                            )}
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className={classes.tableRow}>
                          <TableCell className={`${classes.cell} ${classes.productCodeCell}`} style={{ wordBreak: "break-word" }} align="left">
                            <strong>{formatValue(component?.componentAllocationDetails?.componentCode)}</strong>
                            <span className="description">{formatValue(component?.componentAllocationDetails?.componentName || component?.componentAllocationDetails?.componentDescription)}</span>
                          </TableCell>
                          <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>
                            {component?.componentAllocationDetails?.componentQuantity !== undefined && 
                             component?.componentAllocationDetails?.componentQuantity !== null
                              ? Number(component.componentAllocationDetails.componentQuantity).toFixed(3)
                              : "NA"}
                          </TableCell>
                          <TableCell className={classes.cell} style={{ wordBreak: "break-word" }} align="left">
                            {formatValue(component?.componentAllocationDetails?.componentUOM)}
                          </TableCell>
                          <TableCell className={classes.cell} style={{ wordBreak: "break-word" }} align="left">NA</TableCell>
                          <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>NA</TableCell>
                          <TableCell className={classes.cell} style={{ wordBreak: "break-word" }} align="right">NA</TableCell>
                          <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>NA</TableCell>
                          <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>NA</TableCell>
                          <TableCell className={classes.cell} align="right" style={{ wordBreak: "break-word" }}>
                            {component?.quantityVariance !== undefined && component?.quantityVariance !== null && component?.quantityVariance !== "NA" ? (
                              <span style={{ color: component?.quantityVariancePresent ? "red" : "black" }}>
                                {Number(component.quantityVariance).toFixed(2)}
                              </span>
                            ) : "NA"}
                          </TableCell>
                          <TableCell className={classes.cell} style={{ wordBreak: "break-word" }} align="center">
                            {component?.batchMismatch === "YES" || component?.lotMismatch || component?.lotsMismatch ? (
                              <span style={{ color: "red" }}>Yes</span>
                            ) : "No"}
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow className={classes.tableRow}>
                    <TableCell colSpan={10} className={classes.cell} align="center" style={{ padding: "32px", color: "#999", fontStyle: "italic" }}>
                      No batch allocation data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          */
        )}
        <Box style={{ marginTop: "40px", marginBottom: "30px" }}>
          <Divider />
        </Box>
      </Box>

      {/* Other PO Details Section */}
      <Box>
        <Typography className={classes.sectionTitle}>Other PO Details</Typography>
        <span className={classes.titleBorder}></span>
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>
                  Addressee<br />Org
                </TableCell>
                <TableCell className={classes.headerCell}>City</TableCell>
                <TableCell className={classes.headerCell}>Country</TableCell>
                <TableCell className={classes.headerCell}>
                  Actual CMO<br />Dispatch Date
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Receipt/Collection<br />Date
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Attached<br />Documents
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Date of<br />Creation
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Original<br />Qty.
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {formatValue(addresseeOrg)}
                </TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {formatValue(city)}
                </TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {formatValue(country)}
                </TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {formatValue(dateFormated(actualCMODispatchDate, "DD-MMM-YYYY", "NA"))}
                </TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {formatValue(dateFormated(receiptCollectionDate, "DD-MMM-YYYY", "NA"))}
                </TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {documentsList.filter((file) => file.customFileType === "batch_shipping").length > 0 ? (
                    <Box style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      {documentsList
                        .filter((file) => file.customFileType === "batch_shipping")
                        .map((doc, docIndex) => (
                          <Link
                            key={docIndex}
                            style={{
                              color: "#1a0dab",
                              textDecoration: "none",
                              cursor: "pointer",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              const fileData = {
                                schrockenCustomFileID: doc.schrockenCustomFileID,
                              };
                              dispatch(downloadCustomUploadedFile(fileData));
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.textDecoration = "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.textDecoration = "none";
                            }}
                          >
                            {doc.customFileName}
                          </Link>
                        ))}
                    </Box>
                  ) : (
                    <span style={{ color: "gray", fontStyle: "italic" }}>No files available.</span>
                  )}
                </TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {formatValue(dateFormated(dateOfCreation, "DD-MMM-YYYY", "NA"))}
                </TableCell>
                <TableCell className={classes.cell} style={{ wordBreak: "break-word" }}>
                  {formatValue(originalQty)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* NEW: Comments Section (F9) */}
      <Box style={{ marginTop: "24px" }}>
        <Typography className={classes.sectionTitle}>Comments</Typography>
        <span className={classes.titleBorder}></span>
        <Box style={{ border: "1px solid #ddd", borderRadius: "10px", overflow: "hidden" }}>
          {/* Header bar — blue, matches CommentsBox */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{
              backgroundColor: "#2196f3",
              padding: "10px 16px",
              cursor: "pointer",
              borderRadius: commentsOpen ? "10px 10px 0 0" : "10px",
            }}
            onClick={() => setCommentsOpen((prev) => !prev)}
          >
            <Typography style={{ fontWeight: 500, fontSize: "1rem", color: "#fff" }}>
              Comments section for PO {scheduleLine.scheduleAgreementNumber || poDetails?.poNumber || ""}
            </Typography>
            <ArrowDropDownIcon
              style={{
                color: "#fff",
                transform: commentsOpen ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 0.2s",
              }}
            />
          </Box>

          {/* Messages area — only shown when open */}
          {commentsOpen && (
            <Box
              ref={commentsContainerRef}
              style={{
                height: "300px",
                overflowY: "auto",
                padding: "10px",
                backgroundColor: "#e7ecee",
              }}
            >
              {commentsLoading ? (
                <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <CircularProgress color="primary" thickness={7} />
                </Box>
              ) : comments.length === 0 ? (
                <Typography style={{ color: "#666", fontStyle: "italic", fontSize: "14px", textAlign: "center", marginTop: "24px" }}>
                  No comments available
                </Typography>
              ) : (
                comments.map((msg, idx) => (
                  <Box
                    key={idx}
                    display="flex"
                    flexDirection="column"
                    alignItems={msg.type === "sent" ? "flex-end" : "flex-start"}
                    style={{ marginBottom: "15px" }}
                  >
                    <Box
                      style={{
                        backgroundColor: msg.type === "sent" ? "#dcf8c6" : "#ffffff",
                        color: "#000",
                        padding: "10px",
                        borderRadius: "15px",
                        maxWidth: "80%",
                        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        alignSelf: msg.type === "sent" ? "flex-end" : "flex-start",
                        marginLeft: msg.type === "received" ? "10px" : "auto",
                        marginRight: msg.type === "sent" ? "10px" : "auto",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{ fontWeight: "bold", color: msg.type === "sent" ? "#ef7b52" : "green" }}
                      >
                        {msg.sender}
                      </Typography>
                      <Typography
                        variant="caption"
                        style={{ color: "#929292", display: "block", fontSize: "0.75rem" }}
                      >
                        {msg.isExcelUpload ? `Excel upload, ${msg.time}` : msg.time}
                      </Typography>
                      <Typography variant="body2" style={{ marginBottom: msg.file ? "4px" : 0 }}>
                        {msg.text}
                      </Typography>
                      {msg.file && (
                        <Typography
                          variant="body2"
                          style={{ color: "blue", textDecoration: "underline", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                          onClick={() => handleDownloadCommentFile(msg.schrockenChatID)}
                        >
                          <GetAppIcon fontSize="small" style={{ color: "blue" }} />
                          {msg.file}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))
              )}
            </Box>
          )}
        </Box>
      </Box>

      </Box>
    </Box>

    {/* Form Number Documents Dialog */}
    <Dialog
      open={formNumberDialogOpen}
      onClose={() => setFormNumberDialogOpen(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6">Form Number Documents</Typography>
          <IconButton
            onClick={() => setFormNumberDialogOpen(false)}
            size="small"
            style={{ padding: "4px" }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        {(() => {
          const formNumberFiles = documentsList.filter(
            (file) => file.customFileType === "formNumberDoc"
          );
          
          const formatUploadDate = (dateString) => {
            if (!dateString) return "";
            try {
              const date = moment(dateString);
              return date.format("DD-MMM-YYYY HH:mm:ss");
            } catch (e) {
              return dateString;
            }
          };
          
          if (formNumberFiles.length > 0) {
            return (
              <div style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "8px 0" }}>
                {formNumberFiles.map((file, index) => {
                  const uploadDate = formatUploadDate(file.lastUpdatedDate);
                  
                  return (
                    <div
                      key={file.schrockenCustomFileID || index}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        padding: "8px",
                        borderBottom: index < formNumberFiles.length - 1 ? "1px solid #e0e0e0" : "none",
                      }}
                    >
                      <GetAppIcon
                        style={{
                          fontSize: "24px",
                          marginTop: "2px",
                          cursor: "pointer",
                          color: "#1a0dab",
                        }}
                        onClick={() => {
                          const fileData = {
                            schrockenCustomFileID: file.schrockenCustomFileID,
                          };
                          dispatch(downloadCustomUploadedFile(fileData));
                        }}
                      />
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: 1 }}>
                        <Link
                          component="span"
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: 400,
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            lineHeight: 1.5,
                            letterSpacing: "0.00938em",
                            color: "#1a0dab",
                          }}
                          onClick={() => {
                            const fileData = {
                              schrockenCustomFileID: file.schrockenCustomFileID,
                            };
                            dispatch(downloadCustomUploadedFile(fileData));
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.textDecoration = "underline";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.textDecoration = "none";
                          }}
                        >
                          {file.customFileName}
                        </Link>
                        {uploadDate && (
                          <Typography
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              marginTop: "2px",
                              fontWeight: 400,
                              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              lineHeight: 1.5,
                              letterSpacing: "0.00938em",
                            }}
                          >
                            Uploaded @ {uploadDate}
                          </Typography>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          } else {
            return (
              <Typography style={{ padding: "16px", textAlign: "center", color: "#666" }}>
                No documents available
              </Typography>
            );
          }
        })()}
      </DialogContent>
    </Dialog>
    </React.Fragment>
  );
};

export default PODetails;
